import { useAtom } from 'jotai';
import type { StageSettingsT } from '../../labelling/providers/stage-provider/types';
import { stageSettingsAtom } from '../atoms/stage-atoms';
export const useStageSettings = (): [StageSettingsT, (value: StageSettingsT | ((prev: StageSettingsT) => StageSettingsT)) => void] => {
  const [stageSettings, setStageSettings] = useAtom(stageSettingsAtom);
  return [stageSettings, setStageSettings];
};